import Splide from '@splidejs/splide'
import {type TranslationObject} from '@colonist/i18n'
import {createDivIn, createImgIn, setElementInnerHTML} from '../../../../../../shared/scripts/ui_utils/DomUtils.ts'
import {type LobbyImage} from '@colonist/types'
import {ViewPopup} from '../../../../../../shared/scripts/ui_popup/ViewPopup.ts'

export class UIMStorePopupView extends ViewPopup {
    private readonly imageUrl: LobbyImage
    private readonly description: TranslationObject

    constructor(title: TranslationObject, imageUrl: LobbyImage, description: TranslationObject) {
        super(title,
            {key: 'strings:colonistCommon.utils.emptyString'},
            () => undefined,
            () => undefined,
            true,
            {showXonHeader: true, showXButton: false, showCheckButton: false})

        this.container.classList.add('m-store-popup')
        this.imageUrl = imageUrl
        this.description = description

        this.createBody()
        this.body.style.overflow = 'hidden'

        this.show()
        new Splide('.m-item-swiper', {
            arrows: false,
            pagination: true,
        }).mount()
    }

    protected createBody() {
        const container = createDivIn(this.body, 'splide m-item-swiper')
        const track = createDivIn(container, 'splide__track')
        const list = createDivIn(track, 'splide__list')
        const imageContainer = createDivIn(list, 'splide__slide m-image-container')
        createImgIn(imageContainer, this.imageUrl)

        if(this.description?.options?.value == '') return
        const descriptionContainer = createDivIn(list, 'splide__slide m-description-container')
        const descriptionTextContainer = createDivIn(descriptionContainer, 'm-description-text-container')
        setElementInnerHTML(descriptionTextContainer, this.description)

        createDivIn(container, 'splide__pagination m-store-pagination')

        this.body.append(container)
    }
}
